<template>
  <v-container>
    <v-row>
      <v-col cols=12>
        <h2 class="text-h4 mt-5 mr-5 primary--text">
          {{ $t('sparkPro.subHeading')}}
        </h2>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="6">
        <PolygonProFeatureTable/>
      </v-col>
      <v-col cols="12" md="6">
        <v-img
          contain
          height="100px"
          :src="require('@/assets/images/Polygon_Spark_Pro_logo.png')"
        ></v-img>
        <PolygonDuoImages class="hidden-sm-and-down"/>
        <p class="text--disabled font-italic mt-5">{{ $t('sparkPro.imageText')}}</p>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
export default {}
</script>
